import { mutate } from 'swr'

import { CacheKey } from './cacheKey'

export const mutateCache = (key: CacheKey) => {
  mutate(key)
}
